<template>
  <div v-if="header.value === 'name'">
    <div class="d-flex align-center">
    <user-avatar class="mr-2" :email="item.email" :size="28" />
    <span v-if="item.name === item.email" class="text--disabled font-italic">{{
      $t("general.notSet")
    }}</span>
    <span v-else>{{ item.name }}</span>
    </div>
  </div>
  <div v-else-if="header.value === 'instances_count'">
    <UserInstancesTooltip
      :user="item"
      :instances_count="item.instances_count"
      left
    >
      <v-chip class="label-purple" label> {{ item.instances_count }} </v-chip>
    </UserInstancesTooltip>
  </div>
  <div v-else-if="header.value === 'actions'" :class="isMobile ? '' : 'actions-row'">
    <v-tooltip
      transition="custom-tooltip"
      open-delay="150"
      bottom
      z-index="99"
      offset-overflow
      nudge-bottom="4px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          icon
          small
          @click="$emit('action-button-delete', item)"
        >
          <v-icon>$thrash</v-icon>
        </v-btn>
      </template>

      <span>{{ $t("button.deleteUser") }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    {{ item[header.value] }}
  </div>
</template>

<style lang="scss" scoped>
.theme--light,
.theme--dark {
  .label-purple {
    background: #6A32E033;
    color: #6A32E0;
    height: 24px;
    padding: 0 4px;
    font-weight: 700;
    &.theme--dark{
        color: #B59AFF;
    }
  }
}
</style>

<script>
import UserInstancesTooltip from "./UserInstancesTooltip.vue";
import UserAvatar from "@/components/UserAvatar.vue";

export default {
  components: {
    UserInstancesTooltip,
    UserAvatar,
  },
  props: {
    item: Object,
    header: Object,
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
